import { LRUCache } from 'lru-cache';
import { makeAutoObservable, runInAction } from 'mobx';

import { axiosClient } from '../config/axios-client';
import { Translation } from '../model/Translation';

const BASE_URL = '/translate';

const MAX_TRANSLATION_MAP_SIZE = 50;

class TranslateStore {
  private translationMap = new LRUCache<string, string>({
    max: MAX_TRANSLATION_MAP_SIZE,
  });
  public availableLanguages: string[] = [];

  public constructor() {
    makeAutoObservable(this);
  }

  public initAvailableLanguages = (): Promise<void> =>
    axiosClient.get<string[]>(`${BASE_URL}/languages`).then(response => {
      runInAction(() => {
        this.availableLanguages = response.data;
      });
    });

  public clearCache = (): void => this.translationMap.clear();

  public getAvailableLanguages = (): string[] => this.availableLanguages || [];

  public translate = (text: string, targetLanguage: string): Promise<string> =>
    axiosClient
      .post<string>(BASE_URL, { text, targetLanguage })
      .then(response => {
        this.setTranslation({ text, language: targetLanguage }, response.data);
        return response.data;
      });

  private createHash(key: Translation): string {
    return `${key.language}_#_${key.text}`;
  }

  public setTranslation = (key: Translation, value: string): void => {
    this.translationMap.set(this.createHash(key), value);
  };

  public getTranslation = (key: Translation): string | undefined =>
    this.translationMap.get(this.createHash(key));
}

const translateStore = new TranslateStore();
export default translateStore;
